import {HttpRequest,HttpMethod} from "./http";

class DepartmentProvider extends HttpRequest {

	// CRUD Product	
	DepartmentCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/department`,params );
	}

	DepartmentList(params) {
		return this.request(HttpMethod.Get,`/api/v1/department`,params );
	}

	DepartmentUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/department/${id}`,params );
	}

	DepartmentDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/department/${id}`);
	}


}

export default DepartmentProvider